import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { NAV_LINKS } from "@/lib/site";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto max-w-[1400px] px-5 sm:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-2.5 group">
          <span className="text-white transition-colors duration-200 group-hover:text-cyanbrand">
            <LogoMark className="h-9 w-9" />
          </span>
          <span className="font-display text-lg font-semibold tracking-tight leading-none">
            SC<span className="text-cyanbrand">·</span>Security
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-mono text-xs uppercase tracking-[0.15em] text-white/60 hover:text-cyanbrand transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="https://www.scelectricalandbuildingservices.co.uk"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-sc-electrical-link"
            className="hidden sm:inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2.5 text-sm font-medium text-white/80 transition-colors duration-200 hover:border-cyanbrand hover:text-cyanbrand"
          >
            SC Electrical
            <ExternalLink className="h-3.5 w-3.5" />
          </a>

          <a
            href="#quote"
            data-testid="nav-quote-cta"
            className="group relative inline-flex items-center gap-2 rounded-full bg-cyanbrand px-5 py-2.5 text-sm font-semibold text-black transition-transform duration-200 hover:scale-[1.03]"
          >
            Get a Quote
            <span className="h-1.5 w-1.5 rounded-full bg-black/70 group-hover:animate-pulse" />
          </a>
        </div>
      </nav>
    </motion.header>
  );
};
